import { render, staticRenderFns } from "./applicationFormNew.vue?vue&type=template&id=505cdd6c&scoped=true&"
import script from "./applicationFormNew.vue?vue&type=script&lang=js&"
export * from "./applicationFormNew.vue?vue&type=script&lang=js&"
import style0 from "./applicationFormNew.vue?vue&type=style&index=0&id=505cdd6c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505cdd6c",
  null
  
)

export default component.exports